/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportGeneralRowCreateDto
 */
export interface ImportGeneralRowCreateDto {
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    invoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    currency: ImportGeneralRowCreateDtoCurrencyEnum;
    /**
     * 
     * @type {Date}
     * @memberof ImportGeneralRowCreateDto
     */
    issueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportGeneralRowCreateDto
     */
    sellDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ImportGeneralRowCreateDto
     */
    paymentDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    exchangeRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    type: ImportGeneralRowCreateDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    projectNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    teamsNames?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    attachmentContent: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    attachmentName: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    comment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ImportGeneralRowCreateDto
     */
    tv: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    vat: string;
    /**
     * 
     * @type {string}
     * @memberof ImportGeneralRowCreateDto
     */
    correctedInvoiceNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ImportGeneralRowCreateDto
     */
    correctedInvoiceIssueDate?: Date | null;
}


/**
 * @export
 */
export const ImportGeneralRowCreateDtoCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type ImportGeneralRowCreateDtoCurrencyEnum = typeof ImportGeneralRowCreateDtoCurrencyEnum[keyof typeof ImportGeneralRowCreateDtoCurrencyEnum];

/**
 * @export
 */
export const ImportGeneralRowCreateDtoTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type ImportGeneralRowCreateDtoTypeEnum = typeof ImportGeneralRowCreateDtoTypeEnum[keyof typeof ImportGeneralRowCreateDtoTypeEnum];


/**
 * Check if a given object implements the ImportGeneralRowCreateDto interface.
 */
export function instanceOfImportGeneralRowCreateDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invoiceNumber" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "issueDate" in value;
    isInstance = isInstance && "sellDate" in value;
    isInstance = isInstance && "paymentDate" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "attachmentContent" in value;
    isInstance = isInstance && "attachmentName" in value;
    isInstance = isInstance && "tv" in value;
    isInstance = isInstance && "vat" in value;

    return isInstance;
}

export function ImportGeneralRowCreateDtoFromJSON(json: any): ImportGeneralRowCreateDto {
    return ImportGeneralRowCreateDtoFromJSONTyped(json, false);
}

export function ImportGeneralRowCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportGeneralRowCreateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoiceNumber': json['invoiceNumber'],
        'currency': json['currency'],
        'issueDate': (new Date(json['issueDate'])),
        'sellDate': (new Date(json['sellDate'])),
        'paymentDate': (new Date(json['paymentDate'])),
        'amount': json['amount'],
        'exchangeRate': !exists(json, 'exchangeRate') ? undefined : json['exchangeRate'],
        'type': json['type'],
        'clientId': json['clientId'],
        'companyId': json['companyId'],
        'projectNumber': !exists(json, 'projectNumber') ? undefined : json['projectNumber'],
        'teamsNames': !exists(json, 'teamsNames') ? undefined : json['teamsNames'],
        'attachmentContent': json['attachmentContent'],
        'attachmentName': json['attachmentName'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'tv': json['tv'],
        'vat': json['vat'],
        'correctedInvoiceNumber': !exists(json, 'correctedInvoiceNumber') ? undefined : json['correctedInvoiceNumber'],
        'correctedInvoiceIssueDate': !exists(json, 'correctedInvoiceIssueDate') ? undefined : (json['correctedInvoiceIssueDate'] === null ? null : new Date(json['correctedInvoiceIssueDate'])),
    };
}

export function ImportGeneralRowCreateDtoToJSON(value?: ImportGeneralRowCreateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoiceNumber': value.invoiceNumber,
        'currency': value.currency,
        'issueDate': (value.issueDate.toISOString()),
        'sellDate': (value.sellDate.toISOString()),
        'paymentDate': (value.paymentDate.toISOString()),
        'amount': value.amount,
        'exchangeRate': value.exchangeRate,
        'type': value.type,
        'clientId': value.clientId,
        'companyId': value.companyId,
        'projectNumber': value.projectNumber,
        'teamsNames': value.teamsNames,
        'attachmentContent': value.attachmentContent,
        'attachmentName': value.attachmentName,
        'comment': value.comment,
        'tv': value.tv,
        'vat': value.vat,
        'correctedInvoiceNumber': value.correctedInvoiceNumber,
        'correctedInvoiceIssueDate': value.correctedInvoiceIssueDate === undefined ? undefined : (value.correctedInvoiceIssueDate === null ? null : value.correctedInvoiceIssueDate.toISOString()),
    };
}

